/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { GoArrowRight } from "react-icons/go";
import { FiPlus } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import BookingDetails from './DocAppointment/BookingDetails';
import AddPatient from './DocAppointment/AddPatient';
import { FaStar } from "react-icons/fa";
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import OneSignal from 'react-onesignal';
import { useTranslation } from 'react-i18next';
import LocationImg from "../assets/Image/permission.png";
import { showToast } from '../showTost';
import Loading from './Loading';
import NotificationImg from "../assets/Image/Notification.png";
import secureLocalStorage from "react-secure-storage";
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d4047] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[34px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronLeft color="#fff" size={22} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d4047] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[34px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronRight color="#fff" size={22} />
    </div>
);


const Dashboard = () => {
    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, patientStatus, isLogin, setAgoraAppId, setMapKey, setIsLoginShow, paymentStatus, setPaymentStatus } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [sliderImg, setSliderImg] = useState([]);
    const [bookingData, setBookingData] = useState();
    const [isBooking, setIsBooking] = useState(false);
    const [familyMemberList, setFamilyMemberList] = useState([]);
    const [isPatient, setIsPatient] = useState(false);
    const [relationshipData, setRelationshipData] = useState([]);
    const [booldData, setBooldData] = useState([]);
    const [patientData, setPatientData] = useState();
    const [favoritList, setFavoriteList] = useState([]);
    const [dynamicList, setDynamicList] = useState([]);
    const [deviceCheck, setDeviceCheck] = useState(false);
    const [locationError, setLocationError] = useState(false);
    const [notificationerror, setNotificationError] = useState(false);


    const navigate = useNavigate();
    const initialized = useRef(false);

    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1310, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    const Patientsetting = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 1605, settings: { slidesToShow: 8, slidesToScroll: 1 } },
            { breakpoint: 1445, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1305, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1205, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 380, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const boxsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    const labsetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (Notification.permission === "denied") {
            if (!secureLocalStorage.getItem("notification")) {
                setNotificationError(true);
            }
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = String(position.coords.latitude);
                    const long = String(position.coords.longitude);
                    fetchHomeData(lat, long);
                    HandleGetmember();
                },
                error => {
                    if (!secureLocalStorage.getItem("location")) {
                        setLocationError(true);
                    } else {
                        fetchHomeData(21.215814, 72.828308);
                    }
                }
            );
        }

    }, [isLogin]);

    const fetchHomeData = (lat, long) => {
        setLoading(true);

        const Userid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
            .then((res) => {
                const { banner_data, general_currency, ResponseCode, fav_doctor_list, dynamic_list } = res.data;
                console.log("Home Data", res.data);
                if (ResponseCode === 200) {
                    setLoading(false);
                    setSliderImg(banner_data);
                    setFavoriteList(fav_doctor_list);
                    setDynamicList(dynamic_list);
                    secureLocalStorage.setItem("currency", general_currency.site_currency);
                    OneSignalHandle(general_currency.one_app_id_react);
                    setAgoraAppId(general_currency.agora_app_id);
                    setMapKey(general_currency.google_map_key);
                }
            })
            .catch((error) => {
                console.error("Home Api", error);
            })

    }

    useEffect(() => {
        if (patientStatus) {
            HandleGetmember();
            setIsPatient(false);
        }
    }, [patientStatus])

    const HandleGetmember = () => {
        const Userid = secureLocalStorage.getItem("Userid");


        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/family_member_list`, { id: Userid })
                .then((res) => {
                    // console.log(res);
                    setFamilyMemberList(res.data.family_member);
                })
                .catch((error) => {
                    console.error(error);
                })

            axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
                .then((res) => {
                    const { relationship_list, blood_group_list } = res.data;
                    setRelationshipData(relationship_list);
                    setBooldData(blood_group_list);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        const status = sessionStorage.getItem("Bookid");
        if (status) {
            HandleBookAppointGet(status);
        }
    }, []);

    const HandleBookAppointGet = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/success_appo_detail`, { id: Userid, appointment_id: id })
                .then((res) => {
                    // console.log("success_appo_detail", res);
                    setIsBooking(true);
                    setBookingData(res.data);
                    sessionStorage.removeItem("Bookid");
                })
                .catch((error) => {
                    console.error("success_appo_detail", error);
                })
        }
    }

    const HandleGetPatientDetails = (id) => {
        axios.post(`${ApiBaseUrl}/customer/family_member_detail`, { fid: id })
            .then((res) => {
                // console.log(res);
                setPatientData(res.data.data);
                setIsPatient(true);
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const HandleNavigateDoc = (title, Id, departmentid) => {
        navigate("/doctor-profile");
        sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: departmentid, title, path: "/", pagename: "Home" }));
    }

    const HandleNavigateLab = (item, category) => {
        navigate("/packages");
        sessionStorage.setItem("Docprofile", JSON.stringify({ Categoryid: category, Labid: item.id, title: "Home", path: "/" }));
    }


    const OneSignalHandle = (AppId) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: "8bd31947-bb0d-403f-a1c0-ca017486ede9",
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(() => {

                initialized.current = true;

                OneSignal.User.addTags({
                    "user_id": Userid,
                });
                
            })
                .catch((error) => {
                    console.error("OneSignal :-->>", error);
                });
        }
    }

    const NavigateHandle = (title, id) => {
        navigate("/doctor-details");
        sessionStorage.setItem("Docdetails", JSON.stringify({ id: id, title: title, path: "/", pagename: "Home" }));
    }

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [loading]);

    const HandleAddPatient = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setIsPatient(true);
            setPatientData("");
        } else {
            setIsLoginShow(true);
        }
    }

    useEffect(() => {
        if (!paymentStatus) return;

        if (paymentStatus === "PaymentFaild") {
            showToast({ title: "Payment Closed !!", id: "info" });
            setPaymentStatus("");
        }
    }, [paymentStatus]);

    const HandleLocationEnable = () => {
        setLocationError(false);
        secureLocalStorage.setItem("location", true);
        fetchHomeData(21.215814, 72.828308);

    }

    const HandleNotificationEnable = () => {
        setNotificationError(false);
        secureLocalStorage.setItem("notification", true);
    }

    return (
        <div className="dashboard">
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className=''>
                    <div className="banner slider-container mt-[20px]">
                        <Slider {...settings}>
                            {
                                sliderImg.map((item, index) => {
                                    return <div onClick={() => NavigateHandle(item.department_name, item.department)} className=' relative overflow-hidden cursor-pointer' key={index}>
                                        <img src={ImgBaseUrl + item.image} className='dash_slider_img' alt="Slider Img" />
                                    </div>
                                })
                            }
                        </Slider>
                    </div>

                    <div className="width-container">

                        <div className="section-2 mb-[25px]">
                            <div className="car-gallery">
                                <Link to="/services" className="bg-[#FFEB68] rounded-[15px] px-[30px] py-[25px]">
                                    <h1 className='title'>{t("Doctor Appointment")} {t("Book")}</h1>
                                    <button className="bg-black inline-block rounded-[100%] p-2 cursor-pointer mt-[40px]">
                                        <GoArrowRight className='text-[#FFEB68] text-[20px]' />
                                    </button>
                                </Link>
                                <Link to="/lab-details" className="bg-[#FEC091] rounded-[15px] px-[30px] py-[25px]">
                                    <h1 className='title'>{t("Lab Booking")}</h1>
                                    <button className="bg-black inline-block rounded-[100%] p-2 cursor-pointer mt-[40px]">
                                        <GoArrowRight className='text-[#FEC091] text-[20px]' />
                                    </button>
                                </Link>
                                <Link to="/shop" className="bg-[#FFD6EF] rounded-[15px] px-[30px] py-[25px]">
                                    <h1 className='title'>{t("Medicine Booking")}</h1>
                                    <button className="bg-black inline-block rounded-[100%] p-2 cursor-pointer mt-[40px]">
                                        <GoArrowRight className='text-[#FFD6EF] text-[20px]' />
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <div className="patient">
                            <h1 className='title mb-[10px]'>{t("My Patient")}</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...Patientsetting}>
                                    <div onClick={HandleAddPatient} className="add_box">
                                        <div className="add bg-[#A0E1E1]">
                                            <h1><FiPlus /></h1>
                                        </div>
                                        <h1 className='p_name'>{t("Add New")}</h1>
                                    </div>
                                    {familyMemberList.map((item, index) => {
                                        return <div onClick={() => HandleGetPatientDetails(item.id)} key={index} className="add_box">
                                            <div className="add">
                                                <img src={ImgBaseUrl + item.profile_image} className='w-[100%] h-[100%] object-cover' alt="" />
                                            </div>
                                            <h1 className='p_name'>{item.name}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>

                        {favoritList.length >= 1 && <div className="favorite my-[25px]">
                            <h1 className='title mb-[10px]'>{t("Your favorites")}</h1>
                            <div className="flex items-center gap-[10px] -mt-[10px]">
                                <h1 className='font-[500]'>{t("Doctor your Love")}</h1>
                                <svg width="14" height="13" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.8299 7.46502C16.6569 13.515 8.99998 17 8.99998 17C8.99998 17 1.34292 13.515 0.168923 7.46502C-0.551077 3.75302 1.02197 0.018995 5.02097 -5.02745e-06C7.99997 -0.014005 8.99998 2.98797 8.99998 2.98797C8.99998 2.98797 10 -0.015005 12.978 -5.02745e-06C16.986 0.018995 18.5499 3.75402 17.8299 7.46502Z" fill="#0d4047" />
                                </svg>
                            </div>
                            <div className="slider-container mt-[20px]">
                                <Slider {...Patientsetting}>
                                    {favoritList.map((item, index) => {
                                        return <div onClick={() => HandleNavigateDoc("Doctor Profile", item.id, item.department_id)} key={index} className="add_box cursor-pointer">
                                            <div className="add">
                                                <img src={ImgBaseUrl + item.logo} className='w-[100%] h-[100%] object-cover' alt="" />
                                            </div>
                                            <h1 className='text-[16px] mt-[10px]'>{item.title}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>}

                        <div className="dynamic_list">
                            {dynamicList.map((item, index) => {
                                if ((item.module === "Doctor" || item.module === "Hospital")) {
                                    return <div key={index} className="my-[25px]">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...boxsetting}>
                                                {item.details.map((item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateDoc(item.name, item.id, item.department_id)} className="doctor_box">
                                                        <div className="relative">
                                                            <img src={ImgBaseUrl + item.logo} className='w-[100%] h-[350px] object-cover' alt="" />
                                                            <div className="absolute top-[5px] left-[5px] rating_blur">
                                                                <h1 className='flex items-center text-white gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{item.avg_star}</h1>
                                                            </div>
                                                        </div>
                                                        <div className="p-[10px] w-[100%]">
                                                            <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-ellipsis overflow-hidden'>{item.name}</h1>
                                                            <div className="flex items-center gap-[10px] justify-between">

                                                                <h1 className='flex items-center gap-[5px] font-[500]'>
                                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="gray" />
                                                                    </svg>
                                                                    {item.distance} KM
                                                                </h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                } else if (item.module === "Lab") {
                                    return <div key={index} className="">
                                        <h1 className='title'>{item.title}</h1>
                                        <div className="slider-container mt-[20px]">
                                            <Slider {...labsetting}>
                                                {item.details.map((Item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateLab(Item, item.category)} className="border-[1px] rounded-[10px] p-[10px] cursor-pointer">
                                                        <div className="flex items-center gap-[10px]">
                                                            <img src={ImgBaseUrl + Item.logo} className='w-[80px] h-[90px] object-cover rounded-[10px]' alt="" />
                                                            <div className="overflow-hidden w-full">
                                                                <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.name}</h1>
                                                                <p className='text-[14px] text-gray-600 whitespace-nowrap overflow-hidden overflow-ellipsis'>{Item.address}</p>
                                                                <div className="flex items-center gap-[10px] justify-between">
                                                                    <h1 className='flex items-center gap-[5px] font-[500]'><FaStar className='text-orange-400 text-[17px]' />{Item.avg_star} <span className='text-gray-500'>({Item.tot_review})</span> </h1>
                                                                    <h1 className='flex items-center gap-[5px] font-[500]'>
                                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http:www.w3.org/2000/svg">
                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="black" />
                                                                        </svg>
                                                                        {Item.distance} KM
                                                                    </h1>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                }
                            })}
                        </div>

                    </div>
                </div>}

            {isBooking && <div className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div className="bottme-box">
                    <BookingDetails Data={bookingData} />
                </div>
            </div>}

            {isPatient && <div onClick={() => setIsPatient(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="add-patient">
                    <AddPatient Relation={relationshipData} BooldType={booldData} Data={patientData} />
                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")} <br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

            {locationError && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center">{t('Enable Location Services')}</h2>
                            <img src={LocationImg} alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("To provide accurate services, please enable your location.")}</h6>
                                </div>
                                <div className="flex gap-[5px]">
                                    <span className="text-[18px]">2.</span>
                                    <h6> {t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleLocationEnable} className="bg-[#0d4047] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                            <button onClick={HandleLocationEnable} className="border-[1px] border-[#0d4047] text-[#0d4047] w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Default")}</button>
                        </div>
                    </div>
                </div>
            )}

            {notificationerror && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-bold">{t("Enable Smart Alerts")}</h2>
                            <img src={NotificationImg} className='w-[100%] rounded-[10px]' alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("Let us notify you about upcoming bookings, changes, and key updates directly through your browser.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleNotificationEnable} className="bg-[#0d4047] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Dashboard;
/* jshint ignore:end */